export const iconFontAwesomeCommunicationBullhorn = (
	<i className="fa-solid fa-bullhorn"></i>
);
